// Leaving these functional for now, but there's a lot of repeated params. Might make sense to make this a class.
const convertIndexToStep = (value, stepIncreaseAt, stepIncreaseBy) => {
  if (typeof stepIncreaseAt === 'undefined' || stepIncreaseAt == null) {
    return value;
  }
  // special logic here if step is always higher, mod by zero is NaN
  if (stepIncreaseAt === 0) {
    return value * stepIncreaseBy;
  }

  if (value <= stepIncreaseAt) {
    return value;
  }
  return stepIncreaseAt + (value % stepIncreaseAt) * stepIncreaseBy;
};

const getConvertedCeiling = (values, upperBound, stepIncreaseAt, stepIncreaseBy, multiplier) => {
  if (values[1] === upperBound) {
    return -1;
  }
  return convertIndexToStep(values[1], stepIncreaseAt, stepIncreaseBy) * multiplier;
};

const convertValue = (value, stepIncreaseAt, stepIncreaseBy, multiplier) => {
  return convertIndexToStep(value, stepIncreaseAt, stepIncreaseBy) * multiplier;
};

const formatValue = (value, stepIncreaseAt, stepIncreaseBy) => {
  return convertIndexToStep(value, stepIncreaseAt, stepIncreaseBy).toLocaleString();
};

const getFormattedMax = (value, upperBound, stepIncreaseAt, stepIncreaseBy) => {
  return `${formatValue(value, stepIncreaseAt, stepIncreaseBy)}${value === upperBound ? '+' : ''}`;
};

export const getSliderValues = (values, config) => {
  return {
    convertedRange: [
      convertValue(values[0], config.stepIncreaseAt, config.stepIncreaseBy, config.multiplier),
      getConvertedCeiling(values, config.upperBound, config.stepIncreaseAt, config.stepIncreaseBy, config.multiplier)
    ],
    displayRange: [values[0], values[1]],
    formattedRange: [
      formatValue(values[0], config.stepIncreaseAt, config.stepIncreaseBy),
      getFormattedMax(values[1], config.upperBound, config.stepIncreaseAt, config.stepIncreaseBy)
    ]
  };
};
